//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js'
export default {
    name: 'index',
    mixins: [SEO,JSONSCHEMA],
    data: () => ({
        page: [],
        medicalSections: [],
        medicalSectionsList: [],
        active:0
    }),

    async asyncData({ $api }) {
    const response = await $api.fetchServices();
    const page = response.content;
    const medicalSections = page;
    let medicalSectionsList = [];
    if (medicalSections) {
      const perChunk = 5;
      const result = page.data.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);
        if (!resultArray[chunkIndex]) {
          resultArray[chunkIndex] = [];
        }
        resultArray[chunkIndex].push(item);
        return resultArray;
      }, []);
      medicalSectionsList = result;
    }

    return {
      page,
      medicalSections,
      medicalSectionsList,
      active: 0,
    };
  },
}
